@value headerHeight: 62px;

.content-container {
    position: absolute;
    width: 100%;
    height: calc(100% - headerHeight);
    top: headerHeight;
}

.content-container--header-border {
    border-top: 1px solid var(--off-white-md);
}
